import { useCallback } from "react";
import { Flex, Box, Text, Button, Link } from "@chakra-ui/react";

// assets
import { Arrow } from "icons";

import { IconBackgroundContainer, InfoCardBody } from "theme";

import InfoCard from "@components/InfoCard";
import Icon from "@components/Icon";

import { trackEvent } from "dapp-sdk-v2";

import { AUDITS_VIEW_MORE, AUDIT_TYPE } from "@constants/analytics";

import { getAuditsIcon } from "@utils/common";
import { StrapiAuditsData } from "@customtypes/global";

interface AuditsCardProps {
  title?: string;
  subTitle?: string;
  auditsData: StrapiAuditsData[];
  actionCTA?: string;
  actionLink?: string;
}

const AuditsCard = ({
  title,
  subTitle,
  auditsData,
  actionCTA,
  actionLink,
}: AuditsCardProps) => {
  const onAuditsItemClick = useCallback((key: string) => {
    trackEvent(AUDIT_TYPE, {
      audit_type: key,
    });
  }, []);

  const onAuditsViewMoreClick = useCallback(() => {
    trackEvent(AUDITS_VIEW_MORE, {
      type: "right_sidebar",
    });
  }, []);

  return (
    <InfoCard title={title} subTitle={subTitle}>
      <InfoCardBody>
        {auditsData.map((data, index) => (
          <a
            href={data?.link ? data.link : undefined}
            target="_blank"
            rel="noreferrer"
            onClick={() => onAuditsItemClick(data.key || "")}
            key={data?.key || index}
          >
            <Flex
              justifyContent="space-between"
              alignItems="center"
              mt={index > 0 ? "1rem" : 0}
            >
              <Flex alignItems="center">
                <IconBackgroundContainer>
                  <Box
                    w={{ base: "14px", lg: "20px" }}
                    h={{ base: "12px", lg: "18px" }}
                  >
                    {data.key && (
                      <Icon
                        width="100%"
                        height="100%"
                        color="textSecondary"
                        Icon={getAuditsIcon(data.key)}
                      />
                    )}
                  </Box>
                </IconBackgroundContainer>
                <Text fontSize="14px" ml="1rem" fontWeight="600">
                  {data.title}
                </Text>
              </Flex>
              <Box>
                <Icon
                  height="24px"
                  width="24px"
                  color="textPrimary"
                  Icon={Arrow}
                />
              </Box>
            </Flex>
          </a>
        ))}

        {actionCTA && actionLink ? (
          <Link
            href={actionLink}
            isExternal={true}
            onClick={() => onAuditsViewMoreClick()}
          >
            <Button
              mt="1.5rem"
              variant="none"
              h="40px"
              background="transparent"
              border="1px solid"
              borderColor="seperator"
              borderRadius="6px"
              p="8px 45px"
              w="162px"
              color="textPrimary"
              _light={{
                color: "primary",
              }}
            >
              <Text
                fontWeight="600" // color="textPrimary"
              >
                {actionCTA}
              </Text>
            </Button>
          </Link>
        ) : null}
      </InfoCardBody>
    </InfoCard>
  );
};

export default AuditsCard;
